import { Component, effect, OnInit} from '@angular/core';
import { Menu } from '../menu/menu.model';
import { VerticalMenuComponent } from "../vertical-menu/vertical-menu.component";
import { MenuService } from '../../services/menu.service';
import { AuthenticationService } from '../../../shared/services/authentication/authentication.service';

@Component({
  selector: 'app-sidenav',
  imports: [VerticalMenuComponent],
  templateUrl: './sidenav.component.html',
  styleUrl: './sidenav.component.scss'
})
export class SidenavComponent implements OnInit {
   menuItems: Array<Menu> | undefined;

constructor(
  public menuService: MenuService,
  private authenticationService: AuthenticationService

){
  effect(() => {
    const userRoles = this.authenticationService.getUserRoles();
    this.menuItems = this.menuService.getVerticalMenuItems();
  });

}

  ngOnInit() {
  }
  
  

}
